<template>
    <div class="SacAgendamentoPrincipal">
        <PageTitle icon="fa fa-phone" main="Agendamentos"
            sub="Agendamento dos colaboradores" />
        <div class="Sac-Agendamento-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Agenda" active><SacAgenda /></b-tab>                                                                                                                                            
                    <b-tab title="Parâmetro"><SacParametro /></b-tab>                                                                                                                                            
                    <b-tab title="Indicadores"><SacAgendaPainel /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import SacAgenda from '../sac_agendamento/SacAgendamento'
import SacParametro from '../sac_agendamento/SacAgendamentoParametro'
import SacAgendaPainel from '../sac_agendamento/SacAgendamentoPainel'
export default {
    name: 'SacAgendamentoPrincipal',    
    components: { PageTitle, SacAgenda,SacParametro,SacAgendaPainel}
    
}
</script>

<style>

</style>






